import api from '@/utils/api.js'

const userModule = {
  namespaced: true,
  state: {
    // 从localStorage中读取用户信息，实现持久化
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
    token: localStorage.getItem('token') || '',
    isLoggedIn: !!localStorage.getItem('token')
  },

  mutations: {
    // 设置用户信息
    SET_USER_INFO (state, userInfo) {
      state.userInfo = userInfo
      // 保存到localStorage实现持久化
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },

    // 设置token
    SET_TOKEN (state, token) {
      state.token = token
      state.isLoggedIn = !!token
      // 保存到localStorage实现持久化
      localStorage.setItem('token', token)
    },

    // 清除用户信息
    CLEAR_USER_INFO (state) {
      state.userInfo = null
      state.token = ''
      state.isLoggedIn = false
      // 从localStorage中清除
      localStorage.removeItem('userInfo')
      localStorage.removeItem('token')
      // 清除快捷订单数据
      localStorage.removeItem('quickOrderData')
    }
  },

  actions: {
    // 用户登录
    async login ({ commit }, loginData) {
      try {
        const response = await api.user.login(loginData)
        if (response.code === 200) {
          // 保存用户信息
          const userInfo = {
            ...response.data.userinfo,
          }

          commit('SET_USER_INFO', userInfo)
          // 保存token
          commit('SET_TOKEN', userInfo.token)

          // 快捷订单数据
          localStorage.setItem('quickOrderData', JSON.stringify(response.data.quickOrderData))

          // 如果选择了记住我，可以在这里添加额外的处理
          if (loginData.rememberMe) {
            console.log('用户选择了记住我')
            // 在实际项目中，可以设置更长的过期时间
          }
          return true
        }
      } catch (error) {
      }
    },

    // 用户登出
    async logout ({ commit }) {
      try {
        // 调用API进行登出
        const response = await api.user.logout()
        if (response.code === 200) {
          return true
        }
      } catch (error) {
      } finally {
        // 清除用户信息
        commit('CLEAR_USER_INFO')
      }
    },

    // 检查登录状态
    async checkLoginStatus ({ commit, state }) {

      if (state.token && state.userInfo) {
        try {
          // 验证token是否有效
          let httpdata = {
            token: state.token
          }
          const response = await api.user.getUserInfo(httpdata)
          if (response.code === 1) {
            // 更新用户信息
            const updatedUserInfo = {
              ...state.userInfo,
              ...response.data
            }
            commit('SET_USER_INFO', updatedUserInfo)
            // 确保登录状态为true
            commit('SET_TOKEN', state.token)
            return true
          } else {
            // token无效，清除用户信息
            commit('CLEAR_USER_INFO')
            return false
          }
        } catch (error) {
          console.error('验证登录状态失败:', error)
          // 验证失败，清除用户信息
          commit('CLEAR_USER_INFO')
          return false
        }
      }
      return false
    },
    // 手机号登录
    async mobileLogin ({ commit }, loginData) {
      try {
        const response = await api.user.mobilelogin(loginData)
        if (response.code === 200) {
          // 保存用户信息
          const userInfo = {
            ...response.data.userinfo,
          }

          commit('SET_USER_INFO', userInfo)
          // 保存token
          commit('SET_TOKEN', userInfo.token)

          // 快捷订单数据
          // localStorage.setItem('quickOrderData', JSON.stringify(response.data.quickOrderData))

          // 如果选择了记住我，可以在这里添加额外的处理
          if (loginData.rememberMe) {
            console.log('用户选择了记住我')
            // 在实际项目中，可以设置更长的过期时间
          }
          return true
        }
      } catch (error) {
      }
    },

    // 微信登录
    async wechatLogin ({ commit }, loginData) {
      try {
        const response = await api.user.wechatLogin(loginData)
        if (response.code === 200) {
          // 保存用户信息
          const userInfo = {
            ...response.data.userinfo,
          }

          commit('SET_USER_INFO', userInfo)
          // 保存token
          commit('SET_TOKEN', userInfo.token)

          // 快捷订单数据
          // localStorage.setItem('quickOrderData', JSON.stringify(response.data.quickOrderData))

          // 如果选择了记住我，可以在这里添加额外的处理
          if (loginData.rememberMe) {
            console.log('用户选择了记住我')
            // 在实际项目中，可以设置更长的过期时间
          }
          return true
        }
      } catch (error) {
      }
    },
  },

  getters: {
    // 获取用户信息
    getUserInfo: state => state.userInfo,
    // 获取token
    getToken: state => state.token,
    // 获取登录状态
    getIsLoggedIn: state => state.isLoggedIn,
    // 获取用户名
    getUsername: state => state.userInfo ? state.userInfo.username : ''
  }
}

export default userModule



// WEBPACK FOOTER //
// ./src/store/modules/user.js